<script>
    import { postForm, getIbeHost } from 'shared/Utilities/fetchUtilities';
    import f9button from 'inputs/f9button.vue';
    import errorList from 'shared/Components/errorList.vue';
    import f9input from 'inputs/f9input.vue';
    import f9field from 'inputs/f9field.vue';

    export default {
        props: {
            email: String,
            sliderOpen: Boolean,
            validationScope: {
                type: String,
                default: "forgot-password"
            }
        },
        data() {
            return {
                formInput: "",
                success: false,
                changed: false
            }
        },
        mounted() {
            this.formInput = this.email;
            if(this.formInput) {
                this.changed = true;
            }
        },
        watch: {
            sliderOpen(val) {
                this.success = false;
                this.formInput = this.email;
                if(this.formInput) {
                    this.changed = true;
                }
            }
        },
        components: {
            f9button,
            errorList,
            f9input,
            f9field
        },
        methods: {
            submit() {
                this.$refs.submitButton.focus();
                
                this.validate(this.validationScope).then(result => {
                    if(result) {
                        postForm(this.getHost() + "/Member/ForgotPassword2", {
                            "frontierForgotMemberPassword.Username": this.formInput
                        }).then(x => {
                            if(x.status === 200) {
                                this.success = true;
                                this.changed = false;
                                this.$emit("reset");
                            }
                        });
                    }
                })
            },
            getHost() {
                return getIbeHost();
            }
        },
        computed: {
            disableSubmitButton: function() {
                const isValidEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.formInput);
                const isValidMilesNumber = /^\d+$/.test(this.formInput);

                if (isValidEmail || isValidMilesNumber) {
                    return false;
                };

                return true;
            }
        }
    }
</script>

<template>
    <div class="forgot-container" @keyup="changed = true" @change="changed = true">
        <div v-if="!success">
            <div class="forgot-text">Please enter your email address / <i>FRONTIER</i> Miles<small>sm</small> # below and we will send you an email containing a temporary password. Please make sure you are using the email address associated with your account.</div>
            <error-list :messages="errors.items"></error-list>
            <f9field>
                <span slot="label" class="slider-label">
                    Email Address or <i>FRONTIER</i> Miles<small>sm</small> #
                </span>
                <f9input :saved="!changed" class="slider-input" autocomplete="off" v-model="formInput" @keyup.enter="submit" v-validate="'required'" :data-vv-scope="validationScope" name="email"
                    aria-label="Forgot Password User Name" value="" type="text"></f9input>
            </f9field>
            <f9button :disabled="disableSubmitButton" ref="submitButton" @click="submit">
                Reset
            </f9button>
        </div>
        <div v-else>
            <div>
                <div class="forgot-password-successful-header">
                    If the email address or Frontier number you submitted is associated with your <i>FRONTIER</i> Miles<small>sm</small> account then you will receive a temporary password.
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    .forgot-container {
        .slider-label {
            font-size: 12px;
        }
        
        .forgot-text,
        .forgot-password-successful-header {
            text-transform: none;
            font-weight: 400;
            padding-bottom: 10px;
            font-size: 12px;
        }
    }

    small {
        vertical-align: super;
    }
</style>